import type { ComponentPropsWithoutRef } from 'react';
import React, { useCallback, useEffect, useState } from 'react';

import type { InputProps } from '@platform-ui/input';
import { MaskedInputGlobal } from '@platform-ui/input';

import {
  prefix,
  getPhoneMask,
  getMaskedPhoneNumber,
} from '../../lib/format-phone-number';

type MaskedInputProps = ComponentPropsWithoutRef<typeof MaskedInputGlobal>;

export type InputPhoneProps = Omit<InputProps, 'value' | 'placeholder'> & {
  value: string;
};

const normalizeValue = (value = '') => value.replace(/\s/g, '');

export const InputPhonePh = (props: InputPhoneProps) => {
  const { name, value = '', onChange, ...rest } = props;

  const [mask, setMask] = useState(getPhoneMask(value));

  const handleChange: MaskedInputProps['onChange'] = useCallback(
    (event, params): void => {
      onChange(event, { ...params, value: normalizeValue(params.maskedValue) });
    },
    [onChange]
  );

  const handlePaste = useCallback(
    (event: React.ClipboardEvent): void => {
      event.preventDefault();

      const pastedText = `${prefix}${event.clipboardData
        .getData('Text')
        .replace(/\D/g, '')
        .replace(/^63/, '')}`;

      onChange(null, { value: pastedText, name });
    },
    [onChange, name]
  );

  useEffect(() => {
    setMask((prev) => {
      const phoneMask = getPhoneMask(value);
      return phoneMask.origin === prev.origin ? prev : phoneMask;
    });
  }, [value]);

  return (
    <MaskedInputGlobal
      {...rest}
      name={name}
      type="tel"
      mask={mask.origin}
      maskedValue={getMaskedPhoneNumber(mask, value)}
      placeholder={mask.meta.placeholder}
      fieldDoneStrategy="lastCharInput"
      onChange={handleChange}
      onPaste={handlePaste}
    />
  );
};
